module.exports = __webpack_public_path__ + "2814dabc16ffed8c4b5cbedd1acf4331.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/thrift_savings_plan_2023_chart.png
// module id = 1750
// module chunks = 0